import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "iban",
        'consents',
        "discountCode",
        "referralCode",
        "visitorInfo",
        "visitorInfoHeader",
        "paymentButton",
        "authButton",
        "card",
        "tabsHolder",
        "tab1",
        "tab2",
        "cardHeader"
    ]

    connect() {
        this.updateVisibility()
    }

    updateVisibility() {
        const isTab1Active = this.hasTab1Target && this.tab1Target.classList.contains('active')
        const isTab2Active = this.hasTab2Target && this.tab2Target.classList.contains('active')
        const hasAuthButton = this.hasAuthButtonTarget

        if (isTab2Active && this.hasConsentsTarget) {
            this.consentsTarget.classList.add('d-none')
        }

        if (isTab1Active && hasAuthButton) {
            this.hideElements()
        } else if (isTab1Active && this.hasConsentsTarget) {
            this.consentsTarget.classList.remove('d-none')
        }
        else {
            this.showElements()
        }
    }

    hideElements() {
        if (this.hasIbanTarget) {
            this.ibanTarget.classList.add('d-none')
        }

        if (this.hasDiscountCodeTarget) {
            this.discountCodeTarget.classList.add('d-none')
        }

        if (this.hasReferralCodeTarget) {
            this.referralCodeTarget.classList.add('d-none')
        }

        if (this.hasVisitorInfoTarget) {
            this.visitorInfoTarget.classList.add('d-none')
        }

        if (this.hasVisitorInfoHeaderTarget) {
            this.visitorInfoHeaderTarget.classList.add('d-none')
        }

        if (this.hasPaymentButtonTarget) {
            this.paymentButtonTarget.classList.add('d-none')
        }
    }

    showElements() {
        if (this.hasIbanTarget) {
            this.ibanTarget.classList.remove('d-none')
        }

        if (this.hasDiscountCodeTarget) {
            this.discountCodeTarget.classList.remove('d-none')
        }

        if (this.hasReferralCodeTarget) {
            this.referralCodeTarget.classList.remove('d-none')
        }

        if (this.hasVisitorInfoTarget) {
            this.visitorInfoTarget.classList.remove('d-none')
        }

        if (this.hasVisitorInfoHeaderTarget) {
            this.visitorInfoHeaderTarget.classList.remove('d-none')
        }

        if (this.hasPaymentButtonTarget) {
            this.paymentButtonTarget.classList.remove('d-none')
        }
    }

    tabChanged() {
        this.updateVisibility()
    }
}
